import {updateSliders} from './swiper-product-details';
import axios from "axios"; // Импортируем функцию обновления слайдеров
import {Modal} from 'bootstrap';
/******/
(() => { // webpackBootstrap
    var __webpack_exports__ = {};
    /*!************************!*\
      !*** ./src/js/cart.js ***!
      \************************/
// favorite


    const favorite = document.querySelector('.cart__favorite');
    if (favorite) {
        favorite.addEventListener('click', () => {
            favorite.classList.toggle('activeFavirite');
        });
    }

// buttons

// Функция для обработки клика по кнопке выбора параметра
    function handleWeightButtonClick(button) {
        // Находим родительский элемент кнопки, чтобы очистить только внутри этой группы
        const parent = button.closest('.cart__buttons-top');


        // Меняем активный класс у кнопок только внутри текущей группы
        // Проверяем, имеет ли кнопка класс 'first-level'
        if (button.classList.contains('first-level')) {
            document.querySelectorAll('.filter-button').forEach(el => el.classList.remove('activeWeight'));
        } else {
            parent.querySelectorAll('button.filter-button').forEach(el => el.classList.remove('activeWeight'));
            console.log('Это кнопка второго уровня');
            // Логика для кнопок второго уровня
        }

        button.classList.add('activeWeight');

        // Фильтруем вариации на основе выбранных параметров
        let filteredVariations = filterVariations();
        if (filteredVariations.length > 0) {
            // Обновляем цену на основе отфильтрованных вариаций
            updatePrices(filteredVariations[0]);
            updateImages(filteredVariations[0]);
            updateAddToCart(filteredVariations[0], button)
            updateAvailableAttributes(filteredVariations, button);
            updateAttributesDescProduct(filteredVariations[0], button)
            updateQunatityProduct(filteredVariations[0], button)
            updateBallsProduct(filteredVariations[0], button)

        }
    }

    function updateAddToCart(firstVariation, button) {
        const cartMain = button.closest('.cart__main-info');
        const addToCartButton = cartMain.querySelector('.add-to-cart');
        const addToCartBigButton = document.querySelector('.cart__add-button');
        addToCartButton.setAttribute('data-product_id', firstVariation.id);
        addToCartBigButton.setAttribute('data-product_id', firstVariation.id);
        addToCartBigButton.setAttribute('data-quantity', firstVariation.quantity);

        const stockBtn     = cartMain.querySelector('.stock-request-btn');
        const inStock = Number(firstVariation.quantity) > 0;
        if (inStock) {
            addToCartButton.style.display = '';
            stockBtn.style.display     = 'none';
            stockBtn.replaceWith(stockBtn.cloneNode(true)); // сброс старых обработчиков
        } else {
            addToCartButton.style.display = 'none';
            stockBtn.style.display     = '';
            stockBtn.dataset.productId = firstVariation.id;

            /* вешаем обработчик ОДИН раз на этот экземпляр кнопки */
        }

        const cartContent = button.closest('.cart__content');
        if (cartContent) {
            const favoriteButton = cartContent.querySelector('.favorite-toggle');
            if (favoriteButton) {
                // Обновляем состояние кнопки "В избранное" на основе текущего варианта
                updateFavoriteButtonState(favoriteButton, firstVariation.id);
            }
        }
    }

    function updateFavoriteButtonState(button, productId) {
        // Обновляем атрибуты кнопки "В избранное"
        button.setAttribute('data-id', productId);
        button.setAttribute('data-url', `/favorite/toggle/${productId}`);

        // Проверяем, находится ли текущий вариант в избранном
        axios.get(`/favorite/check/${productId}`)
            .then(response => {

                const data = response.data; // объект, пришедший с сервера

                // 1. Проверяем наличие ключа
                if ('isFavored' in data) {
                    const isFavored = data.isFavored;

                    const labelFavorite = button.querySelector('.favorite-label');
                    if (labelFavorite)
                        labelFavorite.textContent = isFavored ? 'В избранном' : 'В избранное';

                    button.classList.toggle('activeFavirite', isFavored);
                    if (button)
                        button.setAttribute('aria-pressed', isFavored);
                }
                if ('count' in data) {
                    const counter = document.getElementById('favorite-count');
                    if (counter) counter.textContent = data.count;
                }
            })
            .catch(error => {
                console.error('Error checking favorite status:', error);
            });
    }

    function updateAvailableAttributes(filteredVariations, button) {
        if (button.classList.contains('first-level')) {
            // Сначала сбрасываем все кнопки на доступные
            const allButtons = document.querySelectorAll('.filter-button'); // Все кнопки фильтров

            // Для первой группы кнопок (первый уровень) всегда разрешаем их
            const firstLevelButtons = document.querySelectorAll('.filter-button.first-level'); // Кнопки первого уровня
            allButtons.forEach(button => {
                button.disabled = false; // Всегда активируем кнопки первого уровня
            });

            // Собираем все выбранные атрибуты
            let selectedValues = {};
            document.querySelectorAll('.activeWeight').forEach(function (button) {
                selectedValues[button.getAttribute('data-type')] = button.getAttribute('data-value');
            });

            // Перебираем все кнопки и отключаем те, которые не соответствуют текущему фильтру
            allButtons.forEach(button => {
                const buttonType = button.getAttribute('data-type');
                const buttonValue = button.getAttribute('data-value');

                // Если кнопка принадлежит к первому уровню, не отключаем ее
                if (button.classList.contains('first-level')) return;

                // Для кнопок второго уровня фильтруем их в зависимости от выбранных значений
                const matchingVariation = filteredVariations.some(function (variation) {
                    return variation.attributes[buttonType] === buttonValue;
                });

                if (!matchingVariation) {
                    button.disabled = true;
                }
            });
        }
    }


// Функция для фильтрации вариаций
    function filterVariations() {
        var selectedValues = {};

        // Ищем все кнопки с классом .activeWeight
        document.querySelectorAll('.activeWeight').forEach(function (button) {
            // Если кнопка активна (имеет класс 'active')
            selectedValues[button.getAttribute('data-type')] = button.getAttribute('data-value');
        });

        // Фильтруем все вариации по выбранным параметрам
        // Возвращаем отфильтрованные вариации
        return variations.filter(function (variation) {
            return Object.keys(selectedValues).every(function (key) {
                return !selectedValues[key] || variation.attributes[key] === selectedValues[key];
            });
        });
    }

// Функция для обновления цен
    function updatePrices(filteredVariation) {
        const product = document.querySelector('.cart__info-product');  // Находим ближайший контейнер товара

        // Получаем элемент с ценой внутри этого контейнера
        const priceElement = product.querySelector('.price-details');
        const priceWithoutDiscountElement = product.querySelector('.price-without-discount-details');

        // Получаем цену с data-атрибутов
        const price = filteredVariation['price']['price'];
        const priceWithoutDiscount = filteredVariation['price']['without_discount'];

        // Обновляем цену со скидкой
        priceElement.innerHTML = price;

        // Если есть цена без скидки, показываем её
        if (priceWithoutDiscount) {
            priceWithoutDiscountElement.innerHTML = priceWithoutDiscount;
            priceWithoutDiscountElement.style.display = 'inline';  // Показываем элемент
        } else {
            priceWithoutDiscountElement.style.display = 'none';  // Скрываем элемент
        }
    }

    function updateQunatityProduct(filteredVariation) {
        const product = document.querySelector('.cart__info-product');
        const quantity = product.querySelector('.quantity-remain');


        if (!quantity) return;

        // количество берём из filteredVariation.quantity
        const qty = Number(filteredVariation.quantity ?? 0);


        // пишем результат прямо в cartBasket
        if (qty <= 0) {
            quantity.innerHTML = 'Не осталось товаров';
        } else if (qty <= 10) {
            quantity.innerHTML = `Осталось ${qty} ${getProductWord(qty)}`;
        } else {
            quantity.innerHTML = 'Осталось много товаров';
        }

        const discountUntil = product.querySelector('.discount-until-remain');
        if (!discountUntil) return;

        const untilDiscount = filteredVariation.discout_until ?? null;

        if (untilDiscount !== null) {
            discountUntil.innerHTML = `<span class="badge rounded-pill text-bg-danger fs-6">Короткий срок годности</span>`;
        } else {
            discountUntil.innerHTML = '';
        }
    }

    function getProductWord(qty) {
        if (qty === 0) return 'товаров';

        const lastDigit = qty % 10;
        const lastTwoDigits = qty % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return 'товаров';
        if (lastDigit === 1) return 'товар';
        if (lastDigit >= 2 && lastDigit <= 4) return 'товара';
        return 'товаров';
    }

//
    /**
     * Показывает/скрывает блок с бонусными баллами
     * и выводит текст «+N балла/балла/баллов».
     */
    function updateBallsProduct(filteredVariation) {
        const product = document.querySelector('.cart__info-product');
        const cartBalls = product?.querySelector('.cart__balls');
        const ballsSpan = cartBalls?.querySelector('.balls');

        if (!cartBalls || !ballsSpan) return;

        const qty = Number(filteredVariation.balls ?? 0);

        if (qty <= 0) {
            cartBalls.style.display = 'none';
        } else {
            // склоняем слово «балл»
            const word = new Intl.PluralRules('ru').select(qty) === 'one'
                ? 'балл'
                : (new Intl.PluralRules('ru').select(qty) === 'few'
                    ? 'балла'
                    : 'баллов');

            ballsSpan.textContent = `+${qty} ${word}`;
            cartBalls.style.display = '';
        }
    }

    // Функция для обновления верхних характеристик
    function updateAttributesDescProduct(filteredVariation, button) {
        // Находим ближайший контейнер товара
        const cartMain = button.closest('.cart__main');

        // Проверяем, что контейнер товара существует
        if (!cartMain) {
            console.error('Контейнер с классом .cart__main не найден');
            return;
        }

        // Получаем элемент с характеристиками внутри этого контейнера
        const attributesElement = cartMain.querySelector('.cart__characteristics');

        // Проверяем, что элемент с характеристиками существует
        if (!attributesElement) {
            console.error('Элемент с классом .cart__characteristics не найден');
            return;
        }

        // Очистить текущие характеристики
        while (attributesElement.firstChild) {
            attributesElement.removeChild(attributesElement.firstChild);
        }

        // Перебираем массив и создаем новые элементы для каждого объекта
        filteredVariation.attributes_desc_product.forEach(attribute => {
            // Создаем новый элемент div с классом cart__item
            const div = document.createElement('div');
            div.className = 'cart__item';
            div.textContent = attribute.name + ': ' + attribute.value;
            // Создаем элемент dt и добавляем в него имя атрибута
/*            const dt = document.createElement('dt');
            dt.textContent = attribute.name + ':';
            div.appendChild(dt);

            // Создаем элемент dd и добавляем в него значение атрибута
            const dd = document.createElement('dd');
            dd.textContent = attribute.value;
            div.appendChild(dd);*/

            // Добавляем созданный элемент div в attributesElement
            attributesElement.appendChild(div);
        });
    }

    // Функция для обновления изображений в основном и миниатюрном слайдерах
    function updateImages(variation) {

        // Обновляем основной слайдер
        const mainSliderWrapper = document.querySelector('.swiper.main-slider .swiper-wrapper');
        mainSliderWrapper.innerHTML = '';  // Очищаем слайды

        // Добавляем новые изображения в основной слайдер
        variation.images.forEach(imageUrl => {
            const slide = document.createElement('div');
            slide.classList.add('swiper-slide');

            const zoomContainer = document.createElement('div');
            zoomContainer.classList.add('swiper-zoom-container');

            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = 'Product Image';
            img.classList.add('zoom-image');

            zoomContainer.appendChild(img);
            slide.appendChild(zoomContainer);
            mainSliderWrapper.appendChild(slide);
        });

        // Обновляем миниатюрный слайдер
        const thumbSliderWrapper = document.querySelector('.swiper.thumb-slider .swiper-wrapper');
        thumbSliderWrapper.innerHTML = '';  // Очищаем миниатюры

        variation.images.forEach(imageUrl => {
            const slide = document.createElement('div');
            slide.classList.add('swiper-slide');

            const img = document.createElement('img');
            img.src = imageUrl;  // Здесь можно применить фильтр миниатюры, если нужно
            img.alt = 'Product Thumb';

            slide.appendChild(img);
            thumbSliderWrapper.appendChild(slide);
        });

        // Обновляем оба слайдера
        updateSliders();  // Обновляем слайдеры после изменения изображений
    }

// Основная логика, которая привязывает обработчики кликов
    function initWeightButtons() {
        const weightButtons = document.querySelectorAll('.cart__buttons-top button');
        weightButtons.forEach(button => {
            button.addEventListener('click', function () {
                handleWeightButtonClick(button);
            });
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        // Инициализация
        initWeightButtons();

        const weightActiveButtons = document.querySelectorAll('button.activeWeight');
        weightActiveButtons.forEach(button => {
            button.click();
        });


    });

    /* ---------- утилиты ---------- */
    function getQueryParams() {
        return Object.fromEntries(new URLSearchParams(location.search));
    }

    function activateButton(btn) {
        btn.classList.add('activeWeight');
        handleWeightButtonClick(btn);   // ваш готовый обработчик
    }

    /* ---------- стартовая логика ---------- */
    document.addEventListener('DOMContentLoaded', () => {
        const query = getQueryParams();                // {ves:'5kg', ...}
        const allBtns = document.querySelectorAll('.cart__buttons-top button');

        /* 1. ставим активные + фильтруем по ним */
        allBtns.forEach(btn => {
            if (query[btn.dataset.type] === btn.dataset.value) {
                activateButton(btn);
            }
        });

        /* 2. вешаем обработчики на будущие клики */
        allBtns.forEach(btn => btn.addEventListener('click', () => handleWeightButtonClick(btn)));
    });


// counter

    const counter = document.querySelector('.cart__counter span');
    const buttonsCounter = document.querySelectorAll('.cart__counter button');

    if (counter && buttonsCounter) {
        let count = parseInt(counter.textContent);
        buttonsCounter[1].addEventListener('click', () => {
            if (count < 99) {
                counter.textContent = ++count;
            }
        });
        buttonsCounter[0].addEventListener('click', () => {
            if (count > 1) {
                counter.textContent = --count;
            }
        });
    }

// text more
    document.addEventListener('DOMContentLoaded', () => {
        const textFull = document.querySelector('.cart__description div.description');
        const textButton = document.querySelector('.cart__description button');

        // Проверяем, существуют ли элементы
        if (!textFull || !textButton) {
            return;
        }

        let texts = textFull.innerHTML; // Сохраняем HTML-содержимое
        let isTruncated = true;

        textButton.addEventListener('click', () => {
            if (isTruncated) {
                textFull.innerHTML = texts; // Восстанавливаем полное HTML-содержимое
                textButton.textContent = 'Показать меньше';
            } else {
                widthWindow();
                textButton.textContent = 'Показать полностью';
            }
            isTruncated = !isTruncated;
        });

        function widthWindow() {
            if (window.innerWidth <= 1950) {
                // Обрезаем HTML-содержимое, сохраняя корректное закрытие тегов
                let truncatedText = truncateHtml(texts, 880);
                textFull.innerHTML = truncatedText;
            } else {
                textFull.innerHTML = texts; // Восстанавливаем полное HTML-содержимое
            }
        }

// Функция для обрезки HTML-содержимого с сохранением корректного закрытия тегов
        function truncateHtml(html, maxLength) {
            if (html.length <= maxLength) {
                return html; // Если текст короче maxLength, возвращаем его как есть
            }

            // Обрезаем текст до maxLength
            let truncated = html.substring(0, maxLength);

            // Найдем последний закрывающийся тег после maxLength
            let lastTagIndex = truncated.lastIndexOf(/<\/[^>]+>/);

            // Если найден закрывающийся тег, обрезаем до него
            if (lastTagIndex !== -1) {
                truncated = html.substring(0, lastTagIndex + 1);
            }

            // Добавляем многоточие
            truncated += '...';

            return truncated;
        }

        window.addEventListener('resize', widthWindow);
        widthWindow();
    });

// stars

    const stars = document.querySelectorAll('.cart__review-append-stars svg');
    if (stars) {
        let selectedStarIndex = -1;
        stars.forEach((star, index) => {
            star.addEventListener('mouseover', () => {
                highlightStars(index);
            });
            star.addEventListener('mouseout', () => {
                if (selectedStarIndex === -1) {
                    resetStars();
                } else {
                    highlightStars(selectedStarIndex);
                }
            });
            star.addEventListener('click', () => {
                selectedStarIndex = index;
                highlightStars(selectedStarIndex);
            });
        });
    }

    function highlightStars(index) {
        stars.forEach((star, i) => {
            if (i <= index) {
                star.classList.add('highlighted');
            } else {
                star.classList.remove('highlighted');
            }
        });
    }

    function resetStars() {
        stars.forEach(star => {
            star.classList.remove('highlighted');
        });
    }

    // Работаем с Избранное
    document.addEventListener('click', e => {
        const btn = e.target.closest('.favorite-toggle');
        if (!btn) return;

        e.preventDefault();

        axios.post(btn.dataset.url, {}, {
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        }).then(({data}) => {
            btn.classList.toggle('activeFavirite', data.added);
            const labelFavorite = btn.querySelector('.favorite-label');
            if (labelFavorite)
                labelFavorite.textContent = data.added ? 'В избранном' : 'В избранное';
            btn.setAttribute('aria-pressed', data.added);
            /* ---------- УДАЛЯЕМ КАРТОЧКУ при «отжатии» ---------- */
            if (!data.added && location.pathname === '/favorites-list') {
                const card = btn.closest('.card-product');
                if (card) card.remove();          // исчезает без перезагрузки
            }
            // Обновить счётчик в шапке
            const counter = document.getElementById('favorite-count');
            if (counter) counter.textContent = data.count;
        });
    });


    /* =====  открытие модалки  ===== */
    const stockModal = document.getElementById('stockRequestModal');

    stockModal.addEventListener('show.bs.modal', function (event) {
        const button    = event.relatedTarget;
        const productId = button.dataset.productId;   // сохраним в самой модалке
        stockModal.dataset.productId = productId;

        /* сброс ошибок */
        const input = document.getElementById('stockEmail');
        input.classList.remove('is-invalid');
        input.value = '';
        input.nextElementSibling.textContent = '';
    });

    /* =====  клик по «Отправить»  ===== */
    document.getElementById('stockSendBtn').addEventListener('click', function () {
        const email   = document.getElementById('stockEmail').value.trim();
        const token   = document.getElementById('stockToken').value;
        const productId = stockModal.dataset.productId;
        const invalid = document.querySelector('#stockEmail + .invalid-feedback');

        /* простейшая валидация */
        if (!email || !document.getElementById('stockEmail').checkValidity()) {
            invalid.textContent = 'Укажите корректный e-mail';
            document.getElementById('stockEmail').classList.add('is-invalid');
            return;
        }

        invalid.textContent = '';
        document.getElementById('stockEmail').classList.remove('is-invalid');

        axios.post('/product/'+ productId + '/stock-request', {
            email,
            _token: token
        })
            .then(function (response) {
                alert(response.data.message);
                if (stockModal) {
                    let modal = Modal.getInstance(stockModal);
                    modal.hide();
                }
            })
            .catch(function (error) {
                invalid.textContent = error.response?.data?.message || 'Не удалось отправить';
                document.getElementById('stockEmail').classList.add('is-invalid');
            });
    });


    /******/
})()
;
//# sourceMappingURL=cart.js.map